import factory from 'utils/factory';
import lazyFactory from 'utils/lazyFactory';

import Header from 'modules/Header';
import MainNav from 'modules/MainNav';
import CookieBanner from 'modules/CookieBanner';
import Emergency from 'modules/Emergency';
import Accordion from 'modules/Accordion';
import AjaxLoad from 'modules/AjaxLoad';

/**
 * Initialize every organism class found inside `root` (defaults to document).
 * Safe to call repeatedly — factory()/lazyFactory() skip elements that are
 * already marked initialized for a given class, so re-running this against
 * an AJAX-loaded container only wakes the freshly injected nodes.
 */
export default function initOrganisms(root = document) {
  factory(CookieBanner, 'body', {}, root);
  factory(Header, '.js-header', {}, root);
  factory(MainNav, '.js-nav', {}, root);
  factory(Emergency, '.js-emergency', {}, root);
  factory(Accordion, '.js-accordion', {}, root);
  factory(AjaxLoad, '.js-organism-ajax', {}, root);

  lazyFactory(() => import('modules/Search'), '.js-search', {}, root);
  lazyFactory(() => import('modules/FormValidator'), '.js-form form', {}, root);
  lazyFactory(() => import('modules/PowerTools'), '.js-powerTools', {}, root);
  lazyFactory(() => import('modules/StudyPlanFilters'), '.js-pageType-StudyPlanPage', {}, root);
  lazyFactory(() => import('modules/BannerSearch'), '.js-bannerSearchForm', {}, root);
  lazyFactory(() => import('modules/SiteSearchTrigger'), '.js-searchForm', {}, root);
  lazyFactory(() => import('modules/Tabs'), '.js-tabs', {}, root);
  lazyFactory(() => import('modules/HeroVideo'), '.js-heroVideo', {}, root);
  lazyFactory(() => import('modules/Slider'), '.js-slider', {}, root);
  lazyFactory(() => import('modules/Keen'), '.js-keen-slider', {}, root);
  lazyFactory(
    () => import('modules/ActivityCalendar'),
    '.js-activity-calendar',
    {},
    root
  );
  lazyFactory(() => import('modules/Numbers'), '.js-numbers', {}, root);
  lazyFactory(() => import('modules/BooksCarousel'), '.js-booksCarousel', {}, root);
  lazyFactory(() => import('modules/BooksWall'), '.js-booksWall', {}, root);
  lazyFactory(() => import('modules/ArticleShare'), '.js-articleShare', {}, root);
}
